<template>
  <tr class="bg-white">
    <td class="px-6 py-4 text-left whitespace-nowrap text-sm text-gray-500">
      <router-link :to="linkTo">
        <div class="relative flex items-center">
          <div class="inline-flex">
            <StatusTickCross
              :status="statusColor"
            />
          </div>
          <div class="inline-flex ml-2">
            <span class="text-spark-purple font-medium hover:text-indigo-500">
              {{ friendlyName }}
            </span>
          </div>
        </div>
      </router-link>
    </td>
    <td class="px-6 py-4 text-left break-all text-sm text-gray-500">
      <router-link :to="linkTo">
        {{ description }}
      </router-link>
    </td>
    <td class="px-6 py-4 text-left break-all text-sm">
      <router-link :to="linkTo">
        <span
          class="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium capitalize whitespace-nowrap"
          :class="{
            'bg-gray-100 text-grey-700': statusColor === 'grey',
            'bg-red-50 text-red-700': statusColor === 'red',
            'bg-yellow-50 text-yellow-700': statusColor === 'yellow',
            'bg-green-100 text-green-800': statusColor === 'green',
          }"
        >
          {{ statusText }}
        </span>
      </router-link>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';
import StatusTickCross from '@/components/StatusTickCross.vue';
import api from '@/utils/api';

export default {
  name: 'SyncData',
  components: {
    StatusTickCross,
  },
  props: {
    dataType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statusColor: 'grey',
      statusText: 'Loading',
      loading: true,
      complete: false,
    };
  },
  computed: {
    ...mapGetters({
      env: 'env/get',
    }),
    friendlyName() {
      switch (this.dataType) {
        case 'products':
          return 'Prices';
        case 'priceLists':
          return 'Price Lists';
        case 'customers':
          return 'Customers';
        default:
          return 'unknown';
      }
    },
    linkTo() {
      switch (this.dataType) {
        case 'products':
          return '/data-sync/products';
        case 'priceLists':
          return '/products/price-lists';
        case 'customers':
          return '/data-sync/customers';
        default:
          return 'unknown';
      }
    },
    description() {
      switch (this.dataType) {
        case 'products':
          return 'Sends a feed of all purchasable products';
        case 'priceLists':
          return 'Manage your B2B pricing with one or more price lists';
        case 'customers':
          return 'Sends a feed of customers tagged as B2B';
        default:
          return 'unknown';
      }
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      switch (this.dataType) {
        case 'products':
          this.fetch('products');
          break;
        case 'priceLists':
          this.fetchPriceLists();
          break;
        case 'customers':
          this.fetch('customers');
          break;
        default:
          throw new Error('Unknown');
      }
    },
    async fetchPriceLists() {
      const data = await api.sparkApi(this.env.environment, {
        method: 'GET',
        url: '/v1/price-lists',
        body: {},
      });
      if (data.data.length > 1) {
        this.complete = true;
        this.statusColor = 'green';
        this.statusText = 'Data syncing';
      } else {
        this.complete = false;
        this.statusColor = 'green';
        this.statusText = 'Data syncing';
      }
      this.loading = false;
    },
    async fetch(type) {
      if (this.env.platform !== 'shopify' && this.env.platform !== 'shopify_plus') {
        this.complete = true;
        this.statusColor = 'yellow';
        this.statusText = 'Check Platform';
        return;
      }
      const response = await api.get(`/${this.env.environment}/shopify/status/${type}`);
      switch (response.data.status) {
        case 'Processing':
          this.complete = false;
          this.statusColor = 'yellow';
          this.statusText = 'Full Data sync in progress';
          break;
        case 'Completed':
          if (response.data.errors.length) {
            this.complete = false;
            this.statusColor = 'yellow';
            this.statusText = `Data syncing (${response.data.errors.length} errors)`;
          } else {
            this.complete = true;
            this.statusColor = 'green';
            this.statusText = 'Data syncing';
          }
          break;
        case 'Starting':
        default:
          this.complete = false;
          this.statusColor = 'yellow';
          this.statusText = 'Full Data sync starting';
          break;
      }
      this.loading = false;
    },
  },
};
</script>
